// ==========================================================================
// Installing where the browser will not offer it.
//
// Chrome, Edge and Samsung Internet fire `beforeinstallprompt` and show their
// own dialog. Safari never does — not on iPhone, not on iPad, not on a Mac —
// yet all three install the app just as well, from a menu nobody finds on
// their own. So on those the «Install» button opens a short guide instead of
// a dialog, and the ERP installs on every device a company actually carries.
//
// Every browser on iOS and iPadOS is Safari underneath, and since iOS 16.4 all
// of them offer «Add to Home Screen» from their Share menu: Chrome or Firefox
// on an iPad get the same guide.
// ==========================================================================

/**
 * Which guide this device needs, or null when the browser offers its own
 * dialog, cannot install at all, or the app is already installed.
 *
 * @param {object} device
 * @param {string} [device.userAgent]
 * @param {number} [device.maxTouchPoints]
 * @param {boolean} [device.standalone]  already running as the installed app
 * @returns {'iphone'|'ipad'|'mac'|null}
 */
export function manualInstallFor({ userAgent = '', maxTouchPoints = 0, standalone = false } = {}) {
  if (standalone) return null

  if (/iPhone|iPod/.test(userAgent)) return 'iphone'
  if (/iPad/.test(userAgent)) return 'ipad'

  if (/Macintosh/.test(userAgent)) {
    // Since iPadOS 13 an iPad asks for desktop pages and says it is a Mac. The
    // touch screen is what gives it away: no Mac has one.
    if (maxTouchPoints > 1) return 'ipad'
    // Safari on a Mac installs through File → Add to Dock (Safari 17). Every
    // other Mac browser is either Chromium, which has its own dialog, or
    // Firefox, which cannot install: neither needs the guide.
    if (/Version\/(\d+)/.test(userAgent) && /Safari\//.test(userAgent)
      && !/Chrome|Chromium|CriOS|Edg|OPR|Firefox|FxiOS/.test(userAgent)) {
      return Number(userAgent.match(/Version\/(\d+)/)[1]) >= 17 ? 'mac' : null
    }
  }
  return null
}
